module.exports = __webpack_public_path__ + "img/2.f14010a5.png";